var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fade-transition',{attrs:{"leave-absolute":"","hide-on-leave":""}},[(_vm.hasDraft && _vm.draft === null)?_c('v-progress-circular',{staticClass:"mx-auto mt-5",attrs:{"indeterminate":""}}):_c('new-property-form',{attrs:{"propertyDraft":_vm.draft}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }